import { render, staticRenderFns } from "./WBtnApply.vue?vue&type=template&id=5628e872&scoped=true&"
import script from "./WBtnApply.vue?vue&type=script&lang=js&"
export * from "./WBtnApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5628e872",
  null
  
)

export default component.exports